import { getService } from 'data/function';
export class ApplicationProcessor {
    static get CurrentApplicationService() {
        return getService('CurrentApplicationService');
    }
    static async process({ message, trackingProperties, source }) {
        const messageResponse = {
            response: await ApplicationProcessor.CurrentApplicationService.fetchApplication(message.content),
            trackingProperties,
        };
        source.postMessage(messageResponse, '*');
    }
}
